module.exports = __webpack_public_path__ + "static/img/logo-icon-sdhz.0795949a.png";